import { t } from "../i18n";

export default function Footer({ lang, onScrollToExplore, onScrollToPlaylists }) {
  return (
    <footer className="bg-gray-900 text-gray-400 py-16">
      <div className="max-w-7xl mx-auto px-6">
        {/* --- Main 3-column grid --- */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-12">

          {/* Col 1 — Brand */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center flex-shrink-0">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5">
                  <path d="M9 18V5l12-2v13" />
                  <circle cx="6" cy="18" r="3" />
                  <circle cx="18" cy="16" r="3" />
                </svg>
              </div>
              <span className="text-white font-bold text-lg tracking-tight">
                FreeMusic.Top
              </span>
            </div>
            <p className="text-sm text-gray-500 max-w-xs leading-relaxed">
              {t(lang, "siteDescription")}
            </p>
          </div>

          {/* Col 2 — Navigation */}
          <div className="flex flex-col items-center md:items-start">
            <h4 className="text-xs text-gray-500 tracking-widest uppercase mb-4">
              {t(lang, "links")}
            </h4>
            <nav className="flex flex-col items-center md:items-start gap-3">
              <button
                onClick={onScrollToExplore}
                className="text-sm text-gray-400 hover:text-white transition"
              >
                {t(lang, "explore")}
              </button>
              <button
                onClick={onScrollToPlaylists}
                className="text-sm text-gray-400 hover:text-white transition"
              >
                {t(lang, "scenePlaylist")}
              </button>
              <a
                href="/admin"
                className="text-sm text-gray-400 hover:text-white transition"
              >
                {t(lang, "adminPanel")}
              </a>
            </nav>
          </div>

          {/* Col 3 — Contact */}
          <div className="flex flex-col items-center md:items-start">
            <h4 className="text-xs text-gray-500 tracking-widest uppercase mb-4">Contact</h4>
            <div className="flex flex-col items-center md:items-start gap-3">
              <a href="mailto:dean.sinaean@gmail.com" className="text-sm text-gray-400 hover:text-indigo-400 transition">
                dean.sinaean@gmail.com
              </a>
              <a href="https://x.com/DeanSinaean" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-indigo-400 transition">
                𝕏 @DeanSinaean
              </a>
            </div>
          </div>

          {/* Col 4 — QR Codes */}
          <div className="flex flex-col items-center md:items-start">
            <h4 className="text-xs text-gray-500 tracking-widest uppercase mb-4">
              {t(lang, "scanToListen")}
            </h4>
            <div className="flex gap-5">
              {/* Website QR */}
              <div className="flex flex-col items-center gap-2">
                <div className="w-36 h-36 bg-white rounded-xl p-2 shadow-md flex items-center justify-center">
                  <img
                    src="/covers/qr_website.png"
                    alt={t(lang, "websiteQR")}
                    className="w-full h-full object-contain"
                    loading="lazy"
                  />
                </div>
                <span className="text-xs text-gray-500">{t(lang, "websiteQR")}</span>
              </div>
              {/* WeChat Mini Program QR */}
              <div className="flex flex-col items-center gap-2">
                <div className="w-36 h-36 bg-white rounded-xl p-2 shadow-md flex items-center justify-center">
                  <img
                    src="/covers/qr_wechat.png?v=0511"
                    alt={t(lang, "miniProgramQR")}
                    className="w-full h-full object-contain"
                    loading="lazy"
                  />
                </div>
                <span className="text-xs text-gray-500">{t(lang, "miniProgramQR")}</span>
              </div>
            </div>
          </div>

        </div>

        {/* --- Divider --- */}
        <div className="mt-12 mb-6 border-t border-gray-800" />

        {/* --- Friend Links --- */}
        <div className="flex flex-col items-center gap-3 mb-8">
          <span className="text-xs text-gray-500 tracking-wide uppercase">
            {t(lang, "friendLinks")}
          </span>
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2">
            <a href="https://genkee.ai" target="_blank" rel="noopener noreferrer"
              className="text-sm text-gray-400 hover:text-indigo-400 transition">
              genkee.ai
            </a>
            <a href="https://genkeeai.com" target="_blank" rel="noopener noreferrer"
              className="text-sm text-gray-400 hover:text-indigo-400 transition">
              genkeeai.com
            </a>
            <a href="https://story2board.com" target="_blank" rel="noopener noreferrer"
              className="text-sm text-gray-400 hover:text-indigo-400 transition">
              story2board.com
            </a>
            <a href="https://tatamobile.net" target="_blank" rel="noopener noreferrer"
              className="text-sm text-gray-400 hover:text-indigo-400 transition">
              tatamobile.net
            </a>
          </div>
        </div>

        {/* --- Copyright --- */}
        <div className="text-center text-xs text-gray-600">
          {t(lang, "copyright")}
        </div>
      </div>
    </footer>
  );
}
